import { render, staticRenderFns } from "./LabelAdmin.vue?vue&type=template&id=0a7706c8&"
import script from "./LabelAdmin.vue?vue&type=script&lang=js&"
export * from "./LabelAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports